import { ListLayout } from "../../components/listLayout"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { parseLinkHeader } from '@web3-storage/parse-link-header'
import { orderList, paymentList } from "../../redux/slices/subscription"
import { toggleBool } from "../../redux/slices/globalSlice"

export const SubscriptionImport = {
    ListLayout,
    useDispatch,
    useSelector,
    useNavigate,
    useTranslation,
    parseLinkHeader,
    orderList,
    paymentList,
    toggleBool
}
